import { quickNews } from '@/mocks/guagua';

export default function QuickTicker() {
  const loop = [...quickNews, ...quickNews];

  return (
    <section className="bg-accent-500 text-foreground-950 overflow-hidden" aria-label="最新更新快讯">
      <div className="flex items-stretch">
        <div className="flex items-center gap-2 px-4 md:px-6 py-3 bg-primary-500 text-background-50 shrink-0">
          <i className="ri-flashlight-fill animate-pulse-soft" aria-hidden="true"></i>
          <span className="text-sm font-medium whitespace-nowrap">最新更新</span>
        </div>
        <div className="relative flex-1 overflow-hidden">
          <ul className="marquee-track flex items-center w-max whitespace-nowrap animate-marquee-x">
            {loop.map((item, index) => (
              <li key={`${item.time}-${index}`} className="flex items-center gap-2 px-5 text-sm">
                <span className="font-medium text-foreground-950">{item.time}</span>
                <span className="px-1.5 py-0.5 rounded text-[11px] bg-foreground-950/10 text-foreground-900">
                  {item.tag}
                </span>
                <span className="text-foreground-800">{item.text}</span>
                <span className="text-foreground-950/30 pl-3" aria-hidden="true">
                  ·
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}